import React from "react";
import { useRouter } from "next/router";
import { Hooks } from "@xt/xtbase";
import closeIcon from "@/assets/img/proptrading/close.svg";
import backIcon from "@/assets/img/proptrading/back.png";
import styles from "./index.module.scss";

const { useTranslation } = Hooks;

/** 关闭后回到交易所多语言首页，如 /en、/zh-CN */
const getExchangeHomePath = (locale: string | undefined): string => {
  if (locale && locale !== "default") return `/${locale}`;
  return "/";
};

function imgSrc(m: string | { src?: string }) {
  return typeof m === "string" ? m : m?.src ?? String(m);
}

export type ProptradingHeaderRight = "close" | "exchangeRecords";

const ProptradingHeader: React.FC<{
  title?: string;
  showBack?: boolean;
  /** 默认右上角关闭；收益兑换页为「兑换记录」入口 */
  headerRight?: ProptradingHeaderRight;
}> = ({ title = "Prop Trading", showBack = false, headerRight = "close" }) => {
  const router = useRouter();
  const t = useTranslation();

  const handleClose = () => {
    router.push(getExchangeHomePath(router.locale));
  };

  const handleBack = () => {
    if (typeof window !== "undefined" && window.history.length > 1) {
      router.back();
    } else {
      router.push("/proptrading/account");
    }
  };

  const onExchangeRecords = () => {
    const locale = router.locale && router.locale !== "default" ? router.locale : "";
    const base = "/proptrading/account/exchange-records";
    router.push(locale ? `/${locale}${base}` : base);
  };

  return (
    <header className={showBack ? `${styles.header} ${styles.headerWithBack}` : styles.header}>
      {showBack ? (
        <button type="button" className={styles.backBtn} onClick={handleBack} aria-label="back">
          <img src={imgSrc(backIcon)} alt="" className={styles.backIcon} />
        </button>
      ) : null}
      <div className={styles.title}>{title}</div>
      {headerRight === "exchangeRecords" ? (
        <button
          type="button"
          className={styles.exchangeRecordsBtn}
          onClick={onExchangeRecords}
        >
          {t("proptrading.profitExchange.exchangeRecords")}
        </button>
      ) : (
        <button type="button" className={styles.closeBtn} onClick={handleClose} aria-label="close">
          <img src={closeIcon} alt="" className={styles.closeIcon} />
        </button>
      )}
    </header>
  );
};

export default ProptradingHeader;
